export default "__VITE_ASSET__CDW6MXPv__"